import styled from 'styled-components';

export const Wrap = styled.div`
  && {
    background-color: white;
    .section {
      padding: 25px 40px;
    }
    .table {
      margin-top: 40px;
    }
  }
`;
